import { useEffect, useRef } from "react";
import ChatInput from "./ChatInput";
import ChatMessage from "./ChatMessage";
import LoadingCard from "../LoadingCard";

const ChatWindow = ({
  messages,
  onSendMessage,
  disabled,
  loading,
  placeholder = "Ask a question about this paper...",
}) => {
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-xl border border-base-300 bg-base-100 shadow-sm">
      <div className="min-h-0 flex-1 space-y-4 overflow-y-auto p-4">
        {messages.length === 0 && !loading && (
          <div className="flex h-full items-center justify-center text-base-content/60 text-sm">
            Send a message to start the conversation.
          </div>
        )}
        {messages.length === 0 && loading && (
          <LoadingCard
            message="Finding answer…"
            subMessage="Searching within the selected paper."
          />
        )}
        {messages.map((msg, idx) => (
          <ChatMessage
            key={idx}
            role={msg.role}
            content={msg.content}
            pending={msg.pending}
            sources={msg.reranked_chunks}
          />
        ))}
        <div ref={bottomRef} />
      </div>
      <ChatInput
        placeholder={placeholder}
        onSend={onSendMessage}
        disabled={disabled}
        loading={loading}
      />
    </div>
  );
};

export default ChatWindow;
